// https://stackoverflow.com/a/21742107/6253110
export const getMobileOSPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'windows'
  }
  if (/android/i.test(userAgent)) {
    return 'android'
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios'
  }
  return null
}



// WEBPACK FOOTER //
// ./src/lib/featureTest.js